import React from 'react'

export default class trial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: "nuevo"
        }
    }
  

    render() {
        return (
            <div>
               <h1>Su trial a expirado</h1>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/trial/trial.js